import { useState, useCallback, useEffect } from 'react';
import { history, useModel } from 'umi';
import { message } from 'antd';
import { User } from '@/models/http.models';
export default function AuthModel() {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { setSessions } = useModel('sessionModel');
  const api = useModel('apiModel');

  // 通过 umi 全局对象获取路由信息
  // 初始化认证状态
  useEffect(() => {
    const initAuth = () => {
      setIsLoading(true);
      try {
        const storedToken = api.getToken()
        const storedUser = localStorage.getItem('user');

        if (storedToken && storedUser) {
          setUser(JSON.parse(storedUser));
        }
        else {
          common();
        }
      } catch (error) {
        console.error('认证状态恢复失败:', error);
        history.push('/login');
      } finally {
        setIsLoading(false);
      }
    };

    initAuth();
  }, [history, setIsLoading, api, setUser]);

  // 登录方法
  const login = useCallback(async (username: string, password: string,role: String): Promise<boolean> => {
    if (user && api.getToken()) return true;

    setIsLoading(true);
    try {
      // 登录请求直接使用 ofetch
      const response = await api.loginApi(username, password,role)
      if (response) {
        const userData = {
          username,
        }
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
      }

      return response;
    } catch (error) {
      console.error('登录失败:', error);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [setUser, setIsLoading, user, api]);



  // 注册方法
  const register = useCallback(async (values: Record<string, any>): Promise<boolean> => {
    try {
      // 登录请求直接使用 ofetch
      const response = await api.registerApi(values)
      if (response) {
       return true;
      }
      return false;
    } catch (error) {
      console.error('登录失败:', error);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading, api]);

  // 登出方法
  const logout = useCallback(() => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('userInfoAll');
    api.logoutApi();
    common(1);
  }, [history, setUser, api]);

  const common = ((values: any) => {
    // 先获取初始的 type，确保后续不意外修改它
    const initialType = new URLSearchParams(location.search).get('type');
    const authType = localStorage.getItem('authType');
    let finalType;
    if (initialType || authType) {
      if (initialType) {
        localStorage.setItem('authType', initialType);
        finalType = initialType;
      } else {
        finalType = authType;
      }
      // if (values) {
      //   // 这里删除 authType 时，确保 type 已经处理完毕且后续不依赖 authType
      //   localStorage.removeItem('authType');
      // }
      history.push(`/login?type=${finalType}`);
    } else {
      history.push('/login');
    }
  });

  // // 监听token变化，获取会话列表
  // useEffect(() => {
  //   if (api.getToken()) {
  //     api.getHistoryList()
  //       .then(res => {
  //         const { history_list: threads} = res
  //         setSessions(threads);
  //       })
  //       .catch(error => {
  //         console.error('获取会话列表失败:', error);
  //       });
  //   }
  // }, [api, setSessions]);

  return { user, isLoading, login,register, logout };
};
